const keys = {
  propertyCharacteristics: {
    fieldsHelperText: {
      propertyCharacteristics: {
        bathroomsNumber: 'Number of bathrooms',
        constructionYear: 'Year of construction',
        fireHydrantDistance: 'Hydrant distance',
        fireStationDistance: 'Fire station distance',
        propertySize: 'Property size (in sq. ft.)',
        storeysNumber: 'Number of storeys',
        unitsNumber: 'Number of units in the building',
      },
    },
    inputHelpers: {
      constructionYear: {
        description:
          "To find the year of construction, look for the property assessment of your building on your city's website. If you rent, you can ask your landlord or superintendant.",
        title: 'Year of construction',
      },
      fireResistive: {
        description:
          'The term "fire-resistant" refers to the construction of buildings that resist fire damage and prevent the spread of fire.',
        note:
          '<0>NOTE</0>: A building is considered fire-resistant when it has 6 or more units and was built between 1975 and {{0}}.',
        title: 'Fire-Resistant',
      },
      numberOfBathrooms: {
        description:
          'A 1/2 bathroom is simply a room that includes a sink and toilet but not a shower or tub. If the property has many units (eg: duplex, triplex, etc), enter the total number of bathrooms in all units.',
        title: 'Number of bathrooms',
      },
      numberOfStoreys: {
        description: 'Please enter the total number of storeys (excluding basement) in your property.',
        title: 'Number of storeys',
      },
      numberOfUnits: {
        description:
          "Please enter the total number of units in your building. If you're not sure, estimate by multiplying the number of units on a typical floor by the number of floors in the building. If you live in a house, write 1.",
        title: 'Number of units',
      },
      propertySize: {
        description:
          "Please enter the total size of the property in square feet <0>excluding</0> the basement and the garage. If you don't know the size, use the calculator below to find out the size of your property.",
        fields: {
          length: 'Length',
          stories: 'Stories',
          width: 'Width',
        },
        footer: {
          apply: 'Yes',
          measure: 'sq. ft.',
          result: 'Property size',
          subtitle: 'Do you want to use {{0}} sq. ft. for your property size?',
        },
        measurementSystem: {
          imperial: 'Feet',
          metric: 'Meters',
        },
        title: 'Property size',
      },
    },
    titles: {
      isFireResistive: 'Is your building fire-resistant?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
